import React from 'react';
import PropTypes from 'prop-types';
import Editor from './editor';
import * as classes from './classes.module.scss';

const Title = ({
  name, updateAttributes
}) => {
  const setName = (newName) => updateAttributes({ name: newName });

  return (
    <div className={ classes.edit }>
      <Editor name="Wall Title" value={ name } setValue={ setName } />
    </div>
  );
};

Title.propTypes = {
  name: PropTypes.string,
  updateAttributes: PropTypes.func.isRequired
};

export default Title;
